import React from "react";
import { connect } from "react-redux";
import { changeLocation } from "redux/router/actions";
import { presets } from "redux/helpers";
import { formattedDates } from "redux/selectors";
import DatePicker from "components/DatePicker";

const Picker = props => (
  <DatePicker
    initialStartDate={props.start}
    initialEndDate={props.stop}
    onChange={props.onChange}
    presets={presets}
  />
);

const mapStateToProps = (state, ownProps) => ({
  ...formattedDates(state)
});

export default connect(mapStateToProps, {
  changeLocation
})(Picker);
